module Meevo.Plugins.Egifts {
    'use strict';

    import EGiftTemplateCatEnum = Meevo.Model.EGiftTemplateCatEnum;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import MaintenanceFormState = Meevo.Model.MaintenanceFormState;

    export class CardTemplatesSection extends EgiftsBaseTemplate {
        
        public request: EgiftTemplates.ICardTemplatesSectionReq = this.defaultTemplatesReq
        public newTemplate: EgiftCardTemplates.INewTemplate = this.emptyNewTemplateModel;
        public eGiftTemplateTypeEnum: EGiftTemplateType = EGiftTemplateType.GiftCardTemplate;

        constructor(params: ISectionParamsEgifts,
          protected modalService: Meevo.Components.Modal.IModalService,
          protected $q: angular.IQService) {

          super(params, modalService, $q);
        }

        createTemplate(categoryId: EGiftTemplateCatEnum): angular.IPromise<void> {
            return this.egiftsService.createTemplate(this.getNewTemplate(categoryId), true).then(template => {
                this.getData(true);
                this.newTemplate = this.emptyNewTemplateModel;
            }).finally(() => {
                this.templateEditStatus = TemplateEditStatus.None;
                this.context.setMode(MaintenanceFormState.Readonly);
            });
        }

        addNewTemplate(): void {
            this.templateEditStatus = TemplateEditStatus.IsEditingNew;
            this.context.edit();
            this.newTemplate = this.emptyNewTemplateModel;
        }

        private resetValues(): void {
            this.templatesList = {};
            this.newTemplate = this.emptyNewTemplateModel;
        }

        customSave() {
            switch (this.templateEditStatus) {
                case TemplateEditStatus.IsEditingNew:
                      return this.createTemplate(this.newTemplate.eGiftTemplateCatEnum);
                                                      
                case TemplateEditStatus.IsEditingExisting:
                      return this.saveEditedTemplate(this.newTemplate).then((isTemplateSaved) => {
                            if (isTemplateSaved) return;
                              this.templateEditStatus = TemplateEditStatus.IsEditingExisting;
                               return this.$q.reject();
                             });
            }
        }

        ////Data Main////

        get defaultTemplatesReq(): EgiftTemplates.ICardTemplatesSectionReq {
            return {
                criteria: {
                    objectState: null,
                    templateName: null,
                    eGiftTemplateCategoryEnum: null,
                    isGiftCard: true,
                    isEGift: null,
                    businessTypeId: null,
                    priceGroupId: null,
                    filter: null,
                    maintenanceMode: true,
                    isGlobal: true
                },
                asLocationId: 0,
                itemsPerPage: 1000
            };
        }
        
        get emptyNewTemplateModel(): EgiftCardTemplates.INewTemplate {
            return {
                eGiftTemplateCatEnum: null,
                eGiftTemplateTypeEnum: null,
                id: null,
                objectStateEnum: ObjectStateEnum.Inactive,
                templateName: null,
                isGiftCard: true
            };
        }
    }
}